<template>
    <div class="invalid-feedback">
        <span v-if="error && Array.isArray(error)" v-for="(message, index) in error">
            {{ message }}
        </span>

        <span v-if="error && ! Array.isArray(error)">
            {{ error }}
        </span>
    </div>
</template>

<script>
    export default {
    	props: ['error']
    }
</script>